import cn from 'classnames';
import React, { ButtonHTMLAttributes } from 'react';

interface PillProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isSelected?: boolean;
  grow?: boolean;
}

const Pill: React.FC<PillProps> = ({ children, isSelected, grow, disabled, ...props }) => (
  <button
    {...props}
    disabled={disabled}
    className={cn(
      'box-border flex min-w-[90px] items-center justify-center gap-1 whitespace-nowrap rounded-full px-3 py-2 font-semibold outline-none drop-shadow md:min-w-[110px]',
      {
        'border-none bg-neutral-800 text-white': isSelected,
        'border border-solid border-neutral-100 bg-white  text-neutral-800 hover:bg-neutral-100 hover:text-neutral-800 focus:border-2 focus:bg-neutral-200 active:bg-neutral-800 active:text-white':
          !isSelected,
        'bg-neutral-50 text-neutral-300': disabled,
        'w-fit': grow,
      }
    )}>
    {children}
  </button>
);

export default Pill;
